import '../../Bindings/textareaAutoResizeBinding';
import template from './uploadsList.html';
import UploadStatus from '../../Types/enums/UploadStatus';

export function UploadsList(params) {

  var self = this;

  self.uploads = params.uploads;
  self.removeUpload = params.removeUploadCallback;

  self.uploadStatus = UploadStatus; // Make the enum available to the template
}

// The default export returns the component details object to register with KO
export default { viewModel: UploadsList, template: template };
